import React from 'react';
import { Link } from 'react-router-dom';

const JobListing = ({ title, description }) => (
  <div className="bg-white/5 rounded-lg p-8 border border-white/10 backdrop-blur-sm hover:bg-white/10 transition-all duration-300">
    <h3 className="text-2xl font-light text-white mb-4">{title}</h3>
    <p className="text-white/80 font-light leading-relaxed mb-6">{description}</p>
    <a
      href="https://calendly.com/drake-orchestraos"
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center text-blue-400 hover:text-blue-300 transition-colors"
    >
      Apply Now
      <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
      </svg>
    </a>
  </div>
);

const Careers = () => {
  const jobs = [
    {
      title: "Operations Manager",
      description: "Lead the maintenance and uptime of our critical camera network infrastructure. Ensure 24/7 reliability and coordinate with field teams for hardware maintenance and upgrades."
    },
    {
      title: "Computer Vision Engineer",
      description: "Build cutting-edge computer vision systems to extract actionable insights from our video feeds. Work with state-of-the-art ML models and real-time video processing pipelines."
    },
    {
      title: "Cybersecurity Engineer",
      description: "Protect our network and data infrastructure. Implement and maintain security protocols, conduct audits, and ensure compliance with privacy standards."
    },
    {
      title: "Enterprise Sales Representative",
      description: "Drive growth by bringing Orchestra's solutions to major enterprises. Build relationships with key decision-makers and demonstrate the value of our urban intelligence platform."
    },
    {
      title: "Product Manager",
      description: "Shape the future of urban intelligence products. Work closely with engineering, design, and business teams to deliver solutions that transform how cities operate."
    }
  ];

  return (
    <div
      className="min-h-screen bg-black text-white w-full"
      style={{
        overflow: 'auto',
        height: '100vh',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      }}
    >
      <div style={{ height: '100%', overflowY: 'auto' }}>
        {/* Hero Section */}
        <div className="relative pt-32 pb-16 md:pb-24">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-5xl md:text-6xl font-light tracking-wider mb-6">
                Join Orchestra
              </h1>
              <p className="text-xl text-white/80 font-light tracking-wide mb-8 leading-relaxed">
                We're looking for exceptional people to join our mission of making smart cities.
              </p>
            </div>
          </div>
        </div>

        {/* Job Listings */}
        <div className="container mx-auto px-4 pb-24">
          <div className="max-w-4xl mx-auto">
            <div className="grid gap-6">
              {jobs.map((job, index) => (
                <JobListing key={index} {...job} />
              ))}
            </div>
          </div>
        </div>

        {/* Values Section */}
        <div className="bg-white/5 py-24">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-3xl md:text-4xl font-light tracking-wider mb-12">
                Our Values
              </h2>
              <div className="grid md:grid-cols-3 gap-8">
                <div className="p-6">
                  <h3 className="text-xl font-light mb-4">Obsession</h3>
                  <p className="text-white/70 font-light">
                    If you are concerned about work/life balance, this is not the place for you.                  </p>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-light mb-4">High Integrity</h3>
                  <p className="text-white/70 font-light">
                    Our data is our most valuable asset. We are not willing to compromise it for short-term gains.
                  </p>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-light mb-4">Competitive</h3>
                  <p className="text-white/70 font-light">
                    If you are not competitive, this is not the place for you. Underdogs always welcome.
                  </p>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-light mb-4">Big Ego</h3>
                  <p className="text-white/70 font-light">
                    We're doing something epic. It's a moonshot. We're not afraid to fail. We're not afraid to be wrong. We're not afraid to be different.
                  </p>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-light mb-4">Long Term Bets</h3>
                  <p className="text-white/70 font-light">
                    We are in it for the long haul. Where we see ourselves in <strong>5 years</strong> is not interesting. Where we see ourselves in <strong>50 years</strong> is.
                  </p>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-light mb-4">Artistic</h3>
                  <p className="text-white/70 font-light">
                    We're looking for those who excel or moonlight as an artist. If Leonardo Da Vinci, Michelangelo, or Van Gogh were engineers, they would be working at Orchestra.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Benefits Section */}
        {/* <div className="container mx-auto px-4 py-24">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-light tracking-wider mb-12 text-center">
              Benefits & Perks
            </h2>
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-white/5 rounded-lg p-8 border border-white/10">
                <ul className="space-y-4">
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-blue-400 mt-1 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-white/80">Competitive salary & equity</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-blue-400 mt-1 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-white/80">Health, dental & vision insurance</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-blue-400 mt-1 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-white/80">Flexible PTO policy</span>
                  </li>
                </ul>
              </div>
              <div className="bg-white/5 rounded-lg p-8 border border-white/10">
                <ul className="space-y-4">
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-blue-400 mt-1 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-white/80">Remote-friendly work environment</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-blue-400 mt-1 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-white/80">Professional development budget</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-blue-400 mt-1 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-white/80">401(k) with company match</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div> */}


      </div>
      {/* Footer */}
      <footer className="relative bg-black border-t border-white/10 py-8 md:py-12 snap-start">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center mb-8">
            <nav className="mb-6 md:mb-0">
              <ul className="flex flex-wrap justify-center md:justify-start gap-6 md:gap-8">
                <li>
                  <span className="text-white/60 hover:text-white/90 transition-colors text-sm cursor-not-allowed">
                    Docs
                    <span className="ml-2 text-xs text-white/40">(Coming Soon)</span>
                  </span>
                </li>
                <li>
                  <a
                    href="https://calendly.com/drake-orchestraos"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white/60 hover:text-white/90 transition-colors text-sm"
                  >
                    Book a Call
                  </a>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-white/60 hover:text-white/90 transition-colors text-sm"
                  >
                    About
                  </Link>
                </li>
                <li>
                  <Link
                    to="/privacy"
                    className="text-white/60 hover:text-white/90 transition-colors text-sm"
                  >
                    Privacy
                  </Link>
                </li>
                <li>
                  <Link
                    to="/careers"
                    className="text-white/60 hover:text-white/90 transition-colors text-sm"
                  >
                    Careers
                  </Link>
                </li>
              </ul>
            </nav>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-white/40 text-sm mb-4 md:mb-0">
              © 2025 Orchestra, Inc. – Built in San Francisco
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Careers; 